import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Routes, { RouteNames } from './RootRoutes'

import { IndexPage } from './Index'
import { LoginPage } from './Authentication'
import { ProfilePage } from './Profile'
import { ProjectsPage } from './Projects'
import { DetailedProjectPage } from './Projects/Detailed'
import { DetailedInvestmentPage } from './Investment/Detailed'
import { FeedPage } from './Feed'
import { FeedPageDetailed } from './Feed/Detailed'
import { StyleguidePage } from './Styleguide'
import { OnboardingPage } from './Onboarding'
import { ErrorPage } from './Error'
import { Loading } from '../components/molecules/Loading'
import { AuthState, getAuthState } from '../globals/AuthHooks'
import { checkLanguageHasBeenSet } from '../globals/LocalStorageHooks'
import { RedirectPage } from './Redirect'
import { EditChannels } from './Public/EditChannels'
import { PromotionUIPage } from './PromotionUI'
import { PrintableDetailedProject } from './Projects/PrintableDetailedProject'
import { PublicInvestorTest } from './Public/PublicInvestorTest'
import { NotificationsPage } from './Notifications'
import { PublicProjectOverview } from './Public/PublicProjectOverview'

const DefualtSwitch: React.FC = ({ children }) => (
    <Switch>
        <Route exact path={Routes[RouteNames.Styleguide].path}>
            <StyleguidePage />
        </Route>
        <Route exact path="/edit/:id">
            <EditChannels />
        </Route>
        <Route exact path="/promotionui/:projectId">
            <PromotionUIPage />
        </Route>
        <Route exact path="/investor-test">
            <PublicInvestorTest />
        </Route>
        <Route exact path="/public-project-data">
            <PublicProjectOverview />
        </Route>
        {children}
    </Switch>
)

const Authenticated: React.FC = () => (
    <Router>
        <DefualtSwitch>
            <Route exact path={Routes[RouteNames.Home].path}>
                <IndexPage />
            </Route>
            <Route exact path={"/dashboard"}>
                <IndexPage />
            </Route>
            <Route exact path={Routes[RouteNames.Profile].path}>
                <ProfilePage />
            </Route>
            <Route exact path={Routes[RouteNames.Projects].path}>
                <ProjectsPage />
            </Route>
            <Route exact path={Routes[RouteNames.Feed].path}>
                <FeedPage />
            </Route>
            <Route exact path={Routes[RouteNames.FeedDetailed].path}>
                <FeedPageDetailed />
            </Route>
            <Route exact path={Routes[RouteNames.Project].path}>
                <DetailedProjectPage />
            </Route>
            <Route exact path={Routes[RouteNames.Investment].path}>
                <DetailedInvestmentPage />
            </Route>
            <Route exact path={Routes[RouteNames.Styleguide].path}>
                <StyleguidePage />
            </Route>
            <Route exact path='/login'>
                <RedirectPage target='/dashboard' />
            </Route>
            <Route exact path='/signup'>
                <RedirectPage target='/dashboard' />
            </Route>
            <Route exact path='/print/projects/:id'>
                <PrintableDetailedProject/>
            </Route>
            <Route exact path='/notifications'>
                <NotificationsPage />
            </Route>
            <Route exact path='/*'>
                <ErrorPage />
            </Route>
        </DefualtSwitch>
    </Router>
)


const Onboarding: React.FC = () => (
    <Router>
        <DefualtSwitch>
            <Route exact path='*'>
                <OnboardingPage />
            </Route>
        </DefualtSwitch>
    </Router>
)


const NotAuthenticated: React.FC = () => (
    <Router>
        <DefualtSwitch>
            <Route exact path='*'>
                <LoginPage />
            </Route>
        </DefualtSwitch>
    </Router>
)

export default function RootRouter() {
    const [loading, topLoading] = React.useState<boolean>(false);
    const [authenticated, setAuthenticated] = React.useState<AuthState>();

    const setLoading = (state: boolean) => {
        topLoading(state)
        return 0;
    }

    const checkSignIn = async () => {
        setLoading(true)
        await checkLanguageHasBeenSet()
        const authState = await getAuthState()
        setAuthenticated(authState)
        setLoading(false)
    }


    React.useEffect(() => {
        checkSignIn()
        // eslint-disable-next-line
    }, [])
    if (loading || !authenticated) return <Loading />
    if (authenticated === AuthState.FullAccess) return <Authenticated />
    if (authenticated === AuthState.OnboardingAccess) return <Onboarding />
    return <NotAuthenticated />
}
